export const BFF_OBSERVED_ITEM_INDEX = 12;
export const BASIC_GIG_CARD_IMPRESSION_NAME = 'basic_gig_card';
